import * as React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { GoogleDocsViewer } from "./GoogleDocsViewer";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface UploadedFileViewerScreenProps {
  title?: string;
  onBackClick: () => void;
  url: string | null;
}

export class UploadedFileViewerScreen extends React.PureComponent<UploadedFileViewerScreenProps> {
  constructor(props: UploadedFileViewerScreenProps) {
    super(props);
  }

  render() {
    return (
      <Scaffold
        title={
          <ScaffoldTitle
            label={
              this.props.title !== undefined
                ? this.props.title
                : translate(STRINGS.UPLOADED_FILE_VIEW)
            }
          />
        }
        onClickGoBack={this.props.onBackClick}
      >
        <div className="uploadedFileViewer">
          {this.props.url === null || this.props.url.length === 0 ? (
            translate(STRINGS.FILE_NOT_FOUND_CONTACT_AGENCY)
          ) : this.props.url.indexOf(".pdf") === -1 ? (
            <img src={this.props.url} />
          ) : (
            <GoogleDocsViewer documentUrl={this.props.url} />
          )}
        </div>
      </Scaffold>
    );
  }
}
